import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const processed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(loc.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/"); return; }

    (async () => {
      try {
        const res = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        // Store token as fallback in case cookies don't propagate in preview env
        // The backend also sets an httpOnly cookie
        setUser(res.data.user);
        // Also fetch /me to confirm cookie-based auth works; if not, we still have Authorization fallback via localStorage
        // (We cannot access httpOnly cookie but we can pull session token from response? not returned. Use re-call /auth/me)
        try { await api.get("/auth/me"); } catch {}
        const dest = res.data.user?.role === "owner" ? "/owner" : "/account";
        nav(dest, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        nav("/?auth=failed", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="pt-40 text-center text-zinc-400" data-testid="auth-callback">
      <div className="inline-block w-10 h-10 border-2 border-amber-400 border-t-transparent rounded-full animate-spin" />
      <div className="mt-4 font-mono text-xs uppercase tracking-widest">Signing you in…</div>
    </div>
  );
}
